"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserialiseVariableFromText = exports.isTextSerialisedVariable = exports.serialiseVariableAsText = exports.variable = void 0;
var Common_1 = require("ContentTokens/Models/Common");
var BasicBlocks_1 = require("ContentTokens/DataModels/BasicBlocks");
var Types_1 = require("Tokens/Types");
var Text_1 = require("./Text");
var SubstitutionTokenFactory_1 = __importDefault(require("Tokens/SubstitutionTokenFactory"));
exports.variable = {
    createToken: function (token) {
        return {
            type: "inline",
            subType: Common_1.InlineType.Variable,
            isBold: false,
            isItalic: false,
            isStrikethrough: false,
            providerType: token.providerType,
            label: token.name.trim(),
            name: token.apiName.trim(),
            substitutionToken: SubstitutionTokenFactory_1.default.fromLegacyApiToken(token),
        };
    },
    createSlateJson: function (token) {
        return {
            type: Common_1.InlineType.Variable,
            data: {
                variableName: token.apiName,
                variableLabel: token.name,
                isBold: false,
                isItalic: false,
                isStrikethrough: false,
                providerType: token.providerType,
                substitutionToken: SubstitutionTokenFactory_1.default.fromLegacyApiToken(token),
            },
            children: [Text_1.text.createSlateJson()],
            isVoid: true,
        };
    },
};
var serialiseVariableAsText = function (variable) {
    return JSON.stringify(variable);
};
exports.serialiseVariableAsText = serialiseVariableAsText;
var isTextSerialisedVariable = function (text) {
    var data;
    try {
        data = JSON.parse(text);
    }
    catch (e) {
        data = null;
    }
    if ((0, Types_1.isToken)(data)) {
        return {
            isValid: true,
            variable: data,
        };
    }
    return {
        isValid: false,
    };
};
exports.isTextSerialisedVariable = isTextSerialisedVariable;
var deserialiseVariableFromText = function (text) {
    var result = (0, exports.isTextSerialisedVariable)(text);
    if (result.isValid) {
        return {
            isValid: true,
            tokens: [BasicBlocks_1.paragraph.createToken(), exports.variable.createToken(result.variable)],
        };
    }
    return {
        isValid: false,
    };
};
exports.deserialiseVariableFromText = deserialiseVariableFromText;
